const MuiPickersArrowSwitcher = {
  styleOverrides: {
    button: ({ theme }) => ({
      color: theme.palette.grey[800]
    })
  }
};
export {
  MuiPickersArrowSwitcher,
  MuiPickersArrowSwitcher as default
};
